export default {"src":"/_next/static/media/toothBrush_64.be68f1d0.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};